export const BLOCK_SIZE = 20;

export const BORDER_WIDTH = 6;
